<script lang="ts">
  import Typography from "$lib/components/Typography/Typography.svelte";
  import Icon from "$lib/components/Icon/Icon.svelte";
  import { linkTo } from "$lib/utils/url";

  export let quantity = 0;
  export let color = "var(--on-surface)";

  export let dark = false;
</script>

<style lang="scss">
  .basket-icon {
    position: relative;
    display: inline-block;
  }
  .count {
    position: absolute;
    background-color: $inverse-on-surface;
    height: 20px;
    width: 20px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    right: -7px;
    bottom: -6px;

    &__dark {
      background-color: $on-surface;
    }
  }
  a {
    text-decoration: none;
  }
</style>

<div>
  <div class="basket-icon">
    <Icon icon="local_mall" {color} />
    {#if quantity > 0}
      <div class={`count ${!dark && "count__dark"}`}>
        <div class="count--wrapper">
          <Typography
            component="span"
            variant="caption1"
            theme={dark ? "on-surface" : "inverse-on-surface"}
          >
            {quantity <= 99 ? quantity : "99+"}
          </Typography>
        </div>
      </div>
    {/if}
  </div>
</div>
